import {useEffect, useState} from 'react';
import {InfoLabel, SettingsLabel, SmsLabel} from "../../../../config/Config";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import Field from "../../Field";
import Alert from "../../../alert/Alert";
import Loading from "../../../generic/Loading";
import {GetEntities} from "../../../../hooks/UseRequest";


const Sms = (props) => {
    const {journey, currentNode} = props
    const [loading, setLoading] = useState(false)
    const [sms, setSms] = useState([])
    const [landings, setLandings] = useState([])


    const Information = {
        className: 'alert-primary',
        message  : `Through this component you can send SMS Rich messages. `,
        docs     : {
            message: 'For more information, please ',
            path   : '/docs/journeys/sms/'
        }
    }

    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }

    const Title = {
        tab         : 'info',
        name        : 'title',
        type        : 'text',
        label       : 'Title',
        wrapper     : 'form-group',
        placeholder : 'Type an descriptive title',
        node        : currentNode,
        defaultValue: SmsLabel,
    }


    const Description = {
        tab        : 'info',
        name       : 'description',
        type       : 'textarea',
        label      : 'Description',
        wrapper    : 'form-group',
        className  : 'form-control',
        placeholder: 'Type a short description',
        node       : currentNode,
    }


    const ChooseSms = {
        tab            : 'settings',
        name           : 'id_sms',
        type           : 'select',
        label          : 'Choose an sms',
        wrapper        : 'form-group',
        className      : 'input-sm',
        classNamePrefix: 'input-sm',
        placeholder    : 'Choose an sms',
        required       : true,
        isMulti        : false,
        isSearchable   : true,
        options        : sms,
        node           : currentNode,
    }


    const ChooseLanding = {
        tab            : 'settings',
        name           : 'id_landing',
        type           : 'select',
        label          : 'Landing link',
        wrapper        : 'form-group',
        className      : 'input-sm',
        classNamePrefix: 'input-sm',
        placeholder    : 'Choose a landing page',
        required       : false,
        isMulti        : false,
        isSearchable   : true,
        options        : landings,
        node           : currentNode
    }


    const fetchEntities = async () => {
        const options = {
            request: {
                method: 'PUT',
                data  : {
                    offset       : 0,
                    id_enterprise: journey.Audience.Enterprise._id.$oid
                }
            }
        }

        return {
            sms: await GetEntities('/sms/get', {
                toArray: true,
                filters: {id_enterprise: journey?.Audience.Enterprise._id.$oid}
            }),

            landings: await GetEntities('/landings/get', {
                toArray: true, propLabel: 'name',
                filters: {id_enterprise: journey.Audience.Enterprise._id.$oid}
            })
        }
    }


    useEffect(() => {
        setLoading(true)
        fetchEntities().then((response) => {
            setSms(response.sms)
            setLandings(response.landings)
            setLoading(false)
        })
    }, [])


    return (
        <div>
            {loading && <Loading/>}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        <Field {...ChooseSms} />
                                        <Field {...ChooseLanding} />
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Sms;